import axios from "axios";

export default function ({ apiUrl = "", defaultToken = "" } = {}) {
  let token = defaultToken || localStorage.getItem("token");
  let authorization = {};

  if (token) {
    authorization = {
      Authorization: token
    };
  }

  let locale = localStorage.getItem("locale") || "en";
  return axios.create({
    baseURL: apiUrl || process.env.REACT_APP_API_URL,
    headers: {
      "Content-Type": "application/JSON",
      "x-portal": "web",
      "Accept-Language": locale,
      ...authorization
    }
  });
}
